import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Don't trigger error state for ResizeObserver errors
    const resizeObserverErrorPattern = /ResizeObserver loop completed with undelivered notifications/i;
    if (
      (error?.message && typeof error.message === 'string' && resizeObserverErrorPattern.test(error.message)) ||
      (error?.toString && typeof error.toString === 'function' && resizeObserverErrorPattern.test(error.toString()))
    ) {
      return null; // Don't update state, ignore the error
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Ignore ResizeObserver errors - these are harmless browser quirks
    const resizeObserverErrorPattern = /ResizeObserver loop completed with undelivered notifications/i;
    if (
      (error?.message && typeof error.message === 'string' && resizeObserverErrorPattern.test(error.message)) ||
      (error?.toString && typeof error.toString === 'function' && resizeObserverErrorPattern.test(error.toString())) ||
      (errorInfo?.componentStack && typeof errorInfo.componentStack === 'string' && resizeObserverErrorPattern.test(errorInfo.componentStack))
    ) {
      // Silently ignore ResizeObserver errors
      return;
    }
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center', 
          maxWidth: '600px', 
          margin: '0 auto' 
        }}>
          <h2 style={{ color: '#ff69b4' }}>Oops! Something went wrong</h2>
          <p>We're sorry, but there was an error loading this page.</p>
          <p>Please try refreshing the page or contact us if the problem persists.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              background: '#ff69b4',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              margin: '10px'
            }}
          >
            Refresh Page
          </button>
          <a 
            href="/" 
            style={{
              background: '#333',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              margin: '10px',
              textDecoration: 'none',
              display: 'inline-block'
            }}
          >
            Go to Homepage
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 